import * as types from '../../types/eventScheduleTypes';

export const updateScoringAndJudgingSessions = (data) => {
  return {
    type: types.UPDATE_JUDGING_AND_SCORING_SESSIONS,
    payload: data
  }
}
